import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityLink } from './link';

export const SanityImage = z.object({
  _type: z.literal('image'),
  _key: z.string().optional().nullable(),
  _id: z.string(),
  url: z.string(),
  alt: z.string().optional().nullable(),
  width: z.number(),
  height: z.number(),
  lqip: z.string(),
  caption: z.string().optional().nullable(),
  roundedCorners: z.boolean(),
  captionTextAlign: z.enum(['left', 'center']).optional().nullable(),
  link: SanityLink.optional().nullable(),
});
export type SanityImage = z.infer<typeof SanityImage>;

export const image = groq`{
  _type,
  caption,
  captionTextAlign,
  "roundedCorners": coalesce(roundedCorners, false),
  defined(_key) => {
    _key,
  },
  'alt': coalesce(alt, asset->altText),
  ...(asset-> {
    _id,
    url,
    'width': metadata.dimensions.width,
    'height': metadata.dimensions.height,
    'lqip': metadata.lqip,
  })
}`;

/**
 * Studio can leave a shell `{_type, alt}` after clearing an image (no asset).
 * Treat that as null so Zod `SanityImage.nullable()` accepts it.
 */
export const openGraphImageField = groq`'openGraphImage': select(
  defined(openGraphImage.asset->_id) => openGraphImage ${image},
  null
)`;
